// extracted by mini-css-extract-plugin
module.exports = {"dialogBanner":"TranslationUpload_dialog-banner__zxVE7","formResultField":"TranslationUpload_form-result-field__3i__Z"};